import { render, staticRenderFns } from "./mHistoryRecord97.vue?vue&type=template&id=74804ba8&scoped=true"
import script from "./mHistoryRecord97.vue?vue&type=script&lang=js"
export * from "./mHistoryRecord97.vue?vue&type=script&lang=js"
import style0 from "./mHistoryRecord97.vue?vue&type=style&index=0&id=74804ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74804ba8",
  null
  
)

export default component.exports